import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  document.querySelectorAll('[data-footer-to-top]').forEach((button) => {
    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'auto' });
      const firstLink = document.querySelector('header a[href]');
      if (firstLink) firstLink.focus({ preventScroll: true });
    });
  });
});
